import { useMemo } from "react";
import { Vehicle, useGetVehiclesQuery } from "../../../api/vehiclesApi";
import { useSignalR } from "../../../contexts/SignalRContext";

interface UseVehiclesResult {
  vehicles: Vehicle[];
  isLoading: boolean;
  error: string | null;
}

export const useVehicles = (): UseVehiclesResult => {
  const { isConnecting } = useSignalR();

  const {
    data: allVehicles = [],
    isLoading: isQueryLoading,
    error: queryError,
  } = useGetVehiclesQuery();

  const vehicles = useMemo(
    () => allVehicles.filter((v) => !v.isArchived),
    [allVehicles]
  );

  const isLoading = isConnecting || isQueryLoading;
  const error = queryError ? "Failed to load vehicles" : null;

  return {
    vehicles,
    isLoading,
    error,
  };
};
